import { InfoIcon } from 'lucide-react'
import React from 'react'

import { Tooltip } from 'slab'

interface PlanCardFeaturesProps extends Omit<React.HTMLAttributes<HTMLDListElement>, 'className'> {
  children: React.ReactNode;
}

export function PlanCardFeatures ({ children, ...props }: PlanCardFeaturesProps) {
  return <dl {...props} className='flex flex-col gap-4'>{children}</dl>
}

PlanCardFeatures.displayName = 'PlanCard.Features'

export interface PlanCardFeatureProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'className'> {
  detail: React.ReactNode;
  info?: React.ReactNode;
  term: React.ReactNode;
}

export function PlanCardFeature ({ detail, info, term, ...props }: PlanCardFeatureProps) {
  return (
    <div {...props} className='flex flex-col gap-1'>
      <dt className='text-gray-500 body flex items-center'>
        <span>{term}</span>
        {!!info && (
          <span className='ml-1'>
            <Tooltip content={info}>
              <InfoIcon aria-label="(What's this?)" size={16} />
            </Tooltip>
          </span>
        )}
      </dt>
      <dd className='text-gray-800 body-bold'>{detail}</dd>
    </div>
  )
}

PlanCardFeature.displayName = 'PlanCard.Feature'
